import { emailValidationYup, numValidation } from "helpers/validations"
import { t } from "i18next"
import { isValidPhoneNumber } from "react-phone-number-input"
import * as yup from "yup"

const getClientLeadValidationSchema = () =>
  yup.object().shape({
    searchBy: yup.string().required(t("Search by is required")).nullable(),
    searchAffiliate: yup.object().required(t("This Field needs to be selected")).nullable(),
    searchId: numValidation(t("Search ID is required"), 15, "naturalNumbers"),
  })

export default getClientLeadValidationSchema
